import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/GIF_ester.gif'


const _hoisted_1 = { class: "error error--center" }
const _hoisted_2 = { class: "error__code" }
const _hoisted_3 = { class: "error__title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "error__gif",
  alt: "404",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "error__body" }
const _hoisted_6 = { class: "error__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.code), 1),
    _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
    _hoisted_4,
    _renderSlot(_ctx.$slots, "body", {}, () => [
      _createVNode("p", _hoisted_5, [
        _createVNode("span", null, _toDisplayString(_ctx.body), 1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "actions", {}, () => [
        _createVNode(_component_Button, {
          onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goHome())),
          icon: "home",
          title: "Go back Home"
        })
      ])
    ])
  ]))
}